export default __webpack_public_path__ + "static/media/ic_buy_mvlp.d35f5bc2.svg";